import { useState } from "react";
import { fetchWithAuth } from "../../../../../api-client/api_client";
import { showErrorToast, showSuccessToast } from "../../../../shared/Toasts";

interface Params {
  integrationID: string;
  integrationVersionId: string | null;
  onSuccess?: () => void;
  onError?: () => void;
}

const useKickOffAutomatedTests = ({
  integrationID,
  integrationVersionId,
  onSuccess,
  onError: onErrorCallback,
}: Params) => {
  // state
  const [isKickingOff, setIsKickingOff] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const kickOffTests = () => {
    if (!integrationID || !integrationVersionId) {
      showErrorToast("Missing integration ID or integration version ID");
      return;
    }

    setIsKickingOff(true);
    setError(null);

    fetchWithAuth({
      path: `/integrations/${integrationID}/versions/${integrationVersionId}/test-automation/kick-off-all`,
      method: "POST",
      body: {},
      expectJSON: true,
      onResponse: () => {
        setIsKickingOff(false);
        showSuccessToast("Successfully kicked off automated test suites");

        // Call the success callback to trigger polling
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (error) => {
        setIsKickingOff(false);

        // Call error callback to reset running state
        if (onErrorCallback) {
          onErrorCallback();
        }

        error
          ?.json()
          .then((value: string | Record<string, any>) => {
            let errorMessage = "";
            if (typeof value == "string") {
              errorMessage = value;
            } else {
              errorMessage = value?.non_field_errors ?? JSON.stringify(value);
            }
            setError(errorMessage);
            showErrorToast(
              `Failed to kick off automated test suites. Error message: \n ${errorMessage}`
            );
          })
          .catch(() => {
            const errorMessage = "Failed to kick off automated test suites";
            setError(errorMessage);
            showErrorToast(errorMessage);
          });
      },
    });
  };

  return {
    kickOffTests,
    isKickingOff,
    error,
  };
};

export default useKickOffAutomatedTests;
